import { useCallback } from 'react';

import { useChatStore } from '@stores/chat.store';
import { sellerPhoneService } from '../seller-phone.service';
import type { TUseSellerPhoneReturn, TFetchUserPhoneParams } from './use-seller-phone.types';

/** Busca o telefone do vendedor via API REST e atualiza a store. */
export function useSellerPhone(): TUseSellerPhoneReturn {
  const fetchUserPhone = useCallback(
    async (params: TFetchUserPhoneParams): Promise<void> => {
      const { userIdTo, userIdFrom, chatId, chatType } = params;
      const store = useChatStore.getState();
      store.setPhoneLoading(chatId);
      try {
        const phone = await sellerPhoneService.fetchUserPhone({ userIdTo, userIdFrom, chatType });
        useChatStore.getState().setPhoneFulfilled(chatId, phone ?? '');
      } catch (ex: unknown) {
        const message = ex instanceof Error ? ex.message : String(ex ?? '');
        useChatStore.getState().setPhoneRejected(message);
      }
    },
    [],
  );

  return { fetchUserPhone };
}
